import { render } from "./ventatienda.vue?vue&type=template&id=e52be54a&scoped=true"
import script from "./ventatienda.vue?vue&type=script&lang=js"
export * from "./ventatienda.vue?vue&type=script&lang=js"

import "./ventatienda.vue?vue&type=style&index=0&id=e52be54a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e52be54a"]])

export default __exports__